"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REQUEST_STATUS = exports.REQUEST_STATUS_BTTN = exports.REQUEST_STATUS_ID = void 0;
exports.REQUEST_STATUS_ID = {
    REJECT: 3,
    CANCEL: 4,
    APPROVE: 5,
    IN_PROGRESS: 2,
    PENDING: 1,
    REVIEW: 6
};
exports.REQUEST_STATUS_BTTN = [
    { id: exports.REQUEST_STATUS_ID.APPROVE, label: 'Aprobar' },
    { id: exports.REQUEST_STATUS_ID.REJECT, label: 'Rechazar' },
    { id: exports.REQUEST_STATUS_ID.CANCEL, label: 'Cancelar' },
];
exports.REQUEST_STATUS = {
    [exports.REQUEST_STATUS_ID.APPROVE]: {
        path: 'approve',
    },
    [exports.REQUEST_STATUS_ID.REJECT]: {
        path: 'reject',
        warningMssg: "Esta acción provocara un retroceso del flujo. Es necesario reasignar a un paso.",
    },
    [exports.REQUEST_STATUS_ID.CANCEL]: {
        path: 'cancel',
        warningMssg: "Esta acción provocara la finalización completa del flujo"
    }
};
